import { AnimatePresence, motion } from "framer-motion";
import { GoalSection } from "./goalSection";
import { getGoalKey } from "../../../constants-ticker";

export const GoalRotator = ({ goals, goalIndex, className, side }) => {
  const goal = goals[goalIndex % goals.length];

  if (!goal) return <span className={className} />;

  return (
    <AnimatePresence initial={false} mode="wait">
      <motion.span
        key={getGoalKey(goal)}
        className={`${className} ticker-foot-card__goal-rotator`}
        initial={{ opacity: 0, y: 4 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -4 }}
        transition={{ duration: 0.15, ease: "easeInOut" }}
      >
        {GoalSection(goal, side)}
      </motion.span>
    </AnimatePresence>
  );
};